import getHashValueLocationUtil from 'modules/router/utils/get-hash-value'

/**
 * Checks whether the given location pathnames are different.
 * @param  {Object} location1
 * @param  {Object} location2
 * @returns {boolean}
 */
function isDifferentLocationUtil (location1, location2) {
  return (
    getRelativePathLocationUtil(location1) !==
    getRelativePathLocationUtil(location2)
  )
}

/**
 * Get the relative path from the given location object.
 * e.g. `/articles?page=2`
 * @param {Object} location
 * @returns {string}
 */
function getRelativePathLocationUtil (location) {
  if (!location) {
    return ''
  }
  return location.pathname + (location.search || '') + (location.hash || '')
}

/**
 * Gets the hash value of the given location.
 * @param  {Object} location
 * @returns {string}
 */
function hasHashValueLocationUtil (location, value = '') {
  return getHashValueLocationUtil(location).slice(0, value.length) === value
}

/**
 * Add or replace query of the current URL string.
 * @param {Object} data
 *        {string} path
 *        {string} search
 *        {string} name
 *        {String|number} value
 * @returns {string}
 */
function addOrReplaceParameterLocationUtil (data) {
  let {
    name,
    value,
    path,
    search
  } = data
  if (!name || !value) {
    return path
  }
  if (!search && path.indexOf('?') > -1) {
    search = path.slice(path.indexOf('?'))
    path = path.slice(0, path.indexOf('?'))
  }
  // There is no query
  if (!search) {
    path += `?${name}=${value}`
    return path
  }
  // There is queries, split them
  const searchArray = search.split('&')
  const pageSearchIndex = searchArray.findIndex(searchElem => searchElem.indexOf(name) !== -1)
  // Parameter is already in one of the query, replace its value
  if (pageSearchIndex !== -1) {
    const pageSearchElement = searchArray[pageSearchIndex]
    const valueIndex = pageSearchElement.indexOf('=') + 1
    searchArray[pageSearchIndex] = pageSearchElement.slice(0, valueIndex)
    searchArray[pageSearchIndex] += value
  } else {
    // Parameter is not in the query, add it
    searchArray.push(`${name}=${value}`)
  }
  return path + searchArray.join('&')
}

export {
  isDifferentLocationUtil,
  getRelativePathLocationUtil,
  hasHashValueLocationUtil,
  addOrReplaceParameterLocationUtil
}
